module.exports = __webpack_public_path__ + "img/down-monitor-filter.5ee88f95.svg";